import { keys, reduce } from "lodash";
import { InputError } from "../../../hooks/use-form";
import { StructureStatusEnum } from "../../../models/enum/structure-status.enum";
import { SharedValidators } from "../shared/validators";
import { ResidentialStatusEnum } from "../../../models/enum/residential-status.enum";
import { MaritalStatusEnum } from "../../../models/enum/marital-status.enum";
import { IDTypeEnum } from "../../../models/enum/id-type.enum";


export const validateStageBPersonalDetail = (values: any, additional_values: any) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
  
      if(field === "login_user"){
        let validatedResult = validateStageBLoginUser(values.login_user, additional_values);
        return { ...result, [field]: validatedResult };
      }
      
      return { ...result, [field]: {isValid:true} };
    },{}
    );
  return errors;
}


export const validateStageBLoginUser = (values: any, additional_values: any) => {
  const errors: any = reduce(
    keys(values),
    (result, field: string) => {
      let validation: any = { isValid : true };
      if (field === "myinfo") {
        const errors: any = reduce(keys(values.myinfo), (result, field: any, _index: number) => {
          if(values.structure_status === StructureStatusEnum.outgoing && (field === "marital_status")){
            let validation = validateStageBProfileDetailsFields(values.myinfo, field);
            return { ...result, [field.toString()]: validation };
          }
          else{
            //when is incoming, check marital status
            let validation = validateStageBProfileDetailsFields(values.myinfo, field);
            return { ...result, [field.toString()]: validation };
          }
        }, {});
        return errors;
      } else {
        let validation =  validateStageBFields(values, field, additional_values);
        return { ...result, [field.toString()]: validation };
      }
    },
    {}
  );
  return errors;
};


export const validateStageBProfileDetailsFields = (values: any, name: string) => {
  const value = values[name];
  let error: InputError | undefined = { isValid: true };
  switch (name) {
    case "name":
    case "sex":
    case "race":
    case "nationality":
    case "residential_status":
    case "marital_status":
      error = SharedValidators.Basic(value);
      break;
    case "mobile_no":
      error = SharedValidators.Mobile(value);
      break;
    case "email":
      error = SharedValidators.Email(value);
      break;
    case "uinfin":
      error = SharedValidators.Uinfin(value);
      break;
    case "dob":
      error = SharedValidators.Dob(value);
      break;
  }
  return error;
};

export const validateStageBFields = (values: any, name: string, additional_values: any) => {
  const value = values[name];
  const { isLoginRetaining, isLoginOutgoing } = additional_values;
  let error: InputError | undefined = { isValid: true };
  switch (name) {
      case "is_related":
      if(values.structure_order !== "L1"){
        if(!(isLoginRetaining || isLoginOutgoing)){
          error = SharedValidators.Basic(value);
         }
        }
      break;
      case "relationship_with_owner":
        if(!(isLoginRetaining || isLoginOutgoing)){
          if(values.is_related === true && values.structure_order !== "L1"){
            error = SharedValidators.Basic(value);
          }
        }
      break;
      case "spouse":
        if(values.myinfo.marital_status === MaritalStatusEnum.married){
          if(values.spouse_id_type === IDTypeEnum.uinfin || values.spouse_id_type === IDTypeEnum.foreign_id){
             error = SharedValidators.Uinfin(value);
          }else{
            error = SharedValidators.Basic(value);
          }
        }
      break;
      case "spouse_id_type":
        if(values.myinfo.marital_status === MaritalStatusEnum.married){
          error = SharedValidators.Basic(value);
        }
        break;
      case "gross_monthly_income":
        error = SharedValidators.Basic(value);
      break;
      case "spr_obtained_date":
        if(values.myinfo.residential_status === ResidentialStatusEnum.pr){
          if(values.spr_obtained_date === "" || !values.spr_obtained_date){
            error = SharedValidators.Basic(value);
          }
        }
  }
  return error;
}


